import React, { useState } from 'react';
import logger from '../../utils/logger';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './Navbar.css';

function Navbar({
  showAuthButton = false,
  showCartButton = false,
  showBackButton = false,
  showLogoutButton = false,
  onBack,
}) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const { isAuthenticated, signOut } = useAuth();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const handleLogout = async () => {
    try {
      logger.debug('Logout button clicked, starting logout process...');
      const result = await signOut();
      logger.debug('Logout result:', result);
      if (result.success) {
        logger.debug('Logout successful, navigating to home...');
        navigate('/');
      } else {
        logger.error('Logout failed:', result.error);
      }
    } catch (error) {
      logger.error('Logout error:', error);
    }
  };

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      navigate('/home');
    }
  };

  return (
    <nav className="navbar">
      <div className="nav-container">
        <div
          className="nav-brand"
          onClick={() => navigate(isAuthenticated ? '/home' : '/')}
          style={{ cursor: 'pointer' }}
        >
          tiniego
        </div>
        <div className="nav-actions">
          {showCartButton && (
            <button
              className="cart-btn"
              onClick={() => navigate('/cart')}
              title="View Shopping Cart"
            >
              🛒 Cart
            </button>
          )}
          {showBackButton && (
            <button className="back-btn" onClick={handleBack}>
              ← Back to Home
            </button>
          )}
          {showLogoutButton && isAuthenticated && (
            <button className="logout-btn" onClick={handleLogout}>
              Logout
            </button>
          )}
          {showAuthButton && !isAuthenticated && (
            <button className="nav-button" onClick={() => navigate('/auth')}>
              Log in / Sign up
            </button>
          )}
          {isAuthenticated && (
            <div className={`hamburger-menu ${isMenuOpen ? 'open' : ''}`} onClick={toggleMenu}>
              <div className="hamburger-line"></div>
              <div className="hamburger-line"></div>
            </div>
          )}
        </div>
      </div>

      <div className={`dropdown-menu ${isMenuOpen ? 'open' : ''}`}>
        <div className="dropdown-container">
          <ul className="panel-menu" onClick={closeMenu}>
            {isAuthenticated ? (
              <>
                <li>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate('/home');
                    }}
                  >
                    Studio
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate('/cart');
                    }}
                  >
                    Cart
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate('/orders');
                    }}
                  >
                    Orders
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate('/profile');
                    }}
                  >
                    Profile
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      handleLogout();
                    }}
                  >
                    Logout
                  </a>
                </li>
              </>
            ) : (
              <li>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate('/auth');
                  }}
                >
                  Log In / Sign Up
                </a>
              </li>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
